<script setup lang="ts">

const props = withDefaults(defineProps<{
  visible: boolean;
  time?: string,
}>(), {
  time: '0.3s',
});

</script>

<template>
  <Transition
    name="fade"
    appear
  >
    <!--  v-if is used here instead of a root of slot to handle animation abortion.
     Abortion doesnt work when v-if is placed on the root of slot -->
    <template v-if="visible">
      <slot />
    </template>
  </Transition>
</template>

<style scoped>

.fade-enter-active,
.fade-leave-active {
  transition: opacity v-bind('props.time') ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
